import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";
import { usePermission } from "@/hooks/use-permission";

interface ProtectedRouteProps {
  permissions?: string[];
  children: React.ReactNode;
}

export function ProtectedRoute({
  permissions = [],
  children,
}: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLocked = useAuthStore((s) => s.isLocked);
  const location = useLocation();
  const hasPermission = usePermission(permissions);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isLocked) {
    return <Navigate to="/locked" replace />;
  }

  if (permissions.length > 0 && !hasPermission) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}
